export enum CollageCreationType {
    Image,
    Text,
    Symbol
}